"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMax = exports.splitByCompleteness = void 0;
function splitByCompleteness(outputs) {
    const complete = [];
    const incomplete = [];
    outputs.forEach(output => {
        if (output.type === 'complete' ||
            output.type === 'send-max' ||
            output.type === 'opreturn') {
            complete.push(output);
        }
        else {
            incomplete.push(output);
        }
    });
    return {
        complete,
        incomplete,
    };
}
exports.splitByCompleteness = splitByCompleteness;
function getMax(outputs) {
    const countMaxRequests = outputs.filter(output => output.type === 'send-max-noaddress' || output.type === 'send-max');
    if (countMaxRequests.length >= 2) {
        throw new Error('TWO-SEND-MAX');
    }
    const id = outputs.findIndex(output => output.type === 'send-max-noaddress' || output.type === 'send-max');
    const exists = countMaxRequests.length === 1;
    return {
        id,
        exists,
    };
}
exports.getMax = getMax;
